<template>
  <div>
    <div v-if="view === 'unitManagementView'" class="unit-mgmt-manage-view">
      <div class="main-title">
        <p>组织管理</p>
      </div>
      <div class="main-body">
        <el-container>
          <el-aside
            style="border-right: 1px solid #eee"
          >
            <div style="padding: 10px 0">
              <el-input
                class="input"
                prefix-icon="el-icon-search"
                placeholder="搜索部门"
                v-model="param"
              ></el-input>
            </div>
            <el-tree
              class="tree"
              :data="unitTree"
              :props="defaultProps"
              empty-text="加载中…"
              :render-content="renderContent"
              :filter-node-method="filterNode"
              node-key="number"
              check-on-click-node
              highlight-current
              :expand-on-click-node="false"
              :default-expanded-keys="checkedUnitList"
              @node-click="handleNodeClick"
              ref="tree"
            ></el-tree>
          </el-aside>
          <el-main
            ><div style="display: flex; padding: 10px 0; align-items: center">
              <div style="padding: 10px; width: 30%">
                {{ unitInfo.name ? unitInfo.name : "" }}
              </div>
              <div
                style="display: flex; padding: 10px; justify-content: flex-end; flex: 1"
              >
                <el-button
                  type="primary"
                  size="mini"
                  @click="onDeleteUnitBtnClick"
                >
                  删除部门
                </el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="onEditUnitInfoBtnClick"
                >
                  修改名称
                </el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="onAddUnitBtnClick"
                >
                  添加子部门
                </el-button>
              </div>
            </div>
            <el-tabs v-model="activeName" type="card">
              <el-tab-pane label="成员" name="user">
                <div style="padding: 10px 0">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="onAddUserBtnClick"
                  >
                    添加成员
                  </el-button>
                </div>
                <el-table
                  :data="dataList"
                  v-loading="userLoading"
                  :element-loading-text="userLoadingText"
                  element-loading-spinner="el-icon-loading"
                >
                  <el-table-column prop="mobilePhone" label="手机号">
                  </el-table-column>
                  <el-table-column prop="unitName" label="部门">
                  </el-table-column>
                  <el-table-column label="操作" width="250">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="onEditUserBtnClick(scope.row)"
                      >
                        设置所在部门
                      </el-button>
                      <el-button
                        size="mini"
                        type="info"
                        @click="onDeleteUserBtnClick(scope.row)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <div class="page-box">
                  <el-button
                    :disabled="beginIndex <= 0"
                    size="mini"
                    type="primary"
                    @click="onPreBtnClick"
                  >
                    上一页
                  </el-button>
                  <el-button
                    :disabled="dataList.length < pageSize"
                    @click="onNextBtnClick"
                    size="mini"
                    type="primary"
                  >
                    下一页
                  </el-button>
                </div>
              </el-tab-pane>
              <el-tab-pane label="管理员" name="admin">
                <div class="list">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="onAddAdminBtnClick"
                    >添加管理员</el-button
                  >
                </div>
                <el-table
                  :data="dataList"
                  v-loading="userLoading"
                  :element-loading-text="userLoadingText"
                  element-loading-spinner="el-icon-loading"
                >
                  <el-table-column prop="mobilePhone" label="手机号">
                  </el-table-column>
                  <el-table-column label="操作" width="250">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="onEditAdminBtnClick(scope.row)"
                        :disabled="scope.row.disabled"
                        >设置权限</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <div class="page-box" v-if="memberType == 1">
                  <el-button
                    :disabled="beginIndex <= 0"
                    @click="onPreBtnClick"
                    size="mini"
                    type="primary"
                  >
                    上一页
                  </el-button>
                  <el-button
                    :disabled="dataList.length < pageSize"
                    @click="onNextBtnClick"
                    size="mini"
                    type="primary"
                  >
                    下一页
                  </el-button>
                </div>
              </el-tab-pane>
            </el-tabs></el-main
          >
        </el-container>
      </div>
      <el-dialog
        title="修改部门名称"
        :visible.sync="editUnitInfoDialogVisible"
        width="30%"
      >
        <el-form
          label-position="right"
          label-width="80px"
          :model="editUnitInfo"
        >
          <el-form-item label="部门编号">
            <el-input v-model="editUnitInfo.number" disabled></el-input>
          </el-form-item>
          <el-form-item label="部门名称">
            <el-input v-model="editUnitInfo.name"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editUnitInfoDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="editUnitInfoConfirm"
            >确定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="新增子部门"
        :visible.sync="addUnitDialogVisible"
        width="30%"
      >
        <el-form label-position="right" label-width="80px" :model="addUnitData">
          <el-form-item label="部门名称">
            <el-input v-model="addUnitData.name"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addUnitDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onAddUnitConfirm">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="添加用户"
        :visible.sync="addUserDialogVisible"
        width="20%"
      >
        <el-form label-position="right" label-width="80px" :model="addUserData">
          <el-form-item label="手机号">
            <el-select
              v-model="addUserData.number"
              placeholder="手机号"
              filterable
              :loading="loading"
              remote
              :remote-method="queryAllUser"
              loading-text="搜索中"
              default-first-option
            >
              <el-option
                v-for="item in userList"
                :key="item.userAccountNo"
                :label="item.mobilePhone"
                :value="item.userAccountNo"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addUserDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onAddUserConfirm">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="设置成员所在部门"
        :close-on-click-modal="false"
        :visible.sync="editUserDialogVisible"
        width="30%"
      >
        <el-form
          label-position="right"
          label-width="80px"
          :model="editUserData"
        >
          <el-form-item label="成员编号">
            <el-input v-model="editUserData.number" disabled></el-input>
          </el-form-item>
          <el-form-item label="所在部门">
            <el-cascader
              filterable
              :options="unitTree"
              :props="{
                checkStrictly: true,
                value: 'number',
                label: 'name',
                children: 'subUnitList',
              }"
              v-model="editUserData.unitNo"
            ></el-cascader>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editUserDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onEditUserConfirm">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="添加管理员"
        :visible.sync="addAdminDialogVisible"
        width="20%"
      >
        <el-form
          label-position="right"
          label-width="80px"
          :model="addAdminData"
        >
          <el-form-item label="手机号">
            <el-select
              v-model="addAdminData.number"
              placeholder="手机号"
              filterable
              :loading="loading"
              remote
              :remote-method="queryAllAdmin"
              loading-text="搜索中"
              default-first-option
            >
              <el-option
                v-for="item in adminList"
                :key="item.unitMemberNo"
                :label="item.mobilePhone"
                :value="item.unitMemberNo"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="管理权限">
            <el-select
              v-model="addAdminData.schemeList"
              placeholder="请选择"
              multiple
            >
              <el-option
                v-for="item in confSchemeList"
                :key="item.number"
                :label="item.name"
                :value="item.number"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addAdminDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onAddAdminConfirm">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="设置管理员权限"
        :visible.sync="editAdminDialogVisible"
        width="30%"
      >
        <el-form
          label-position="right"
          label-width="100px"
          :model="editAdminData"
        >
          <el-form-item label="管理员编号">
            <el-input v-model="editAdminData.number" disabled></el-input>
          </el-form-item>
          <el-form-item
            label="不可管理权限"
            v-if="editAdminData.extraSchemeList.length > 0"
          >
            <el-tag
              :style="index > 0 ? 'margin-left: 4px;' : ''"
              v-for="(extra, index) in editAdminData.extraSchemeList"
              :key="extra.number"
              >{{ extra.name }}</el-tag
            >
          </el-form-item>
          <el-form-item label="管理权限">
            <el-select
              v-model="editAdminData.schemeList"
              placeholder="请选择"
              multiple
            >
              <el-option
                v-for="item in confSchemeList"
                :key="item.number"
                :label="item.name"
                :value="item.number"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editAdminDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onEditAdminConfirm">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="导入文件"
        :visible.sync="uploadDialogVisible"
        width="30%"
      >
        <el-form label-position="right" label-width="80px">
          <el-form-item label>
            <el-upload
              ref="fileUpload"
              action
              accept=".xls, .xlsx"
              :limit="1"
              :auto-upload="false"
              :on-change="handleFile"
              :file-list="uploadFileList"
            >
              <el-button>添加文件</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="uploadDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onImportBtnConfirm">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Utils from "../utils/utils";
export default {
  name: "unitMgmt",
  data() {
    return {
      token: Utils.getLocalStorage("token"),
      param: "",
      unitNavCrumbs: "",
      activeName: "user",
      checkedUnitList: [],
      unitInfo: {
        unitNo: "",
        name: "",
        memberNum: 0,
      },
      editUnitInfoDialogVisible: false,
      editUnitInfo: {
        unitNo: "",
        name: "",
        location: "",
      },
      addUnitDialogVisible: false,
      addUnitData: {
        name: "",
        location: "",
      },
      addUserDialogVisible: false,
      addUserData: {
        number: "",
      },
      addAdminDialogVisible: false,
      addAdminData: {
        number: "",
        schemeList: [],
      },
      editAdminDialogVisible: false,
      editAdminData: {
        number: "",
        schemeList: [],
        extraSchemeList: [],
      },
      authoritySchemeList: [],
      authoritySchemeNo: "",
      userList: [],
      adminList: [],
      phoneAndName: "",
      dataList: [],
      preBtnDisabled: true,
      nextBtnDisabled: true,
      beginIndex: 0,
      pageSize: 10,
      loading: false,
      file: null,
      uploadDialogVisible: false,
      uploadFileList: [],
      editUserData: {
        unitMemberNo: "",
        userAccountNo: "",
        authoritySchemeNo: "",
      },
      editUserDialogVisible: false,
      unitTree: [],
      defaultProps: {
        children: "subUnitList",
        label: "name",
      },
      view: "unitManagementView",
      userAccountNo: "",
      unitMemberNo: "",
      userInfo: {},
      userLoading: false,
      userLoadingText: ''
    };
  },
  computed: {
    filterSchemeList() {
      return {
        "": "全部",
        ...this.authoritySchemeList,
      };
    },
    confSchemeList() {
      return {
        ...this.authoritySchemeList,
      };
    },
    memberType() {
      const map = {
        user: 1,
        admin: 2,
      };
      return map[this.activeName];
    },
  },
  watch: {
    memberType() {
      this.onQueryBtnClick();
    },
    $route() {
      this.unitInfo = this.$qs.parse(this.$route.query);
      this.onQueryBtnClick();
    },
    param(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.queryManagedUnit();
  },
  mounted() {
    this.unitInfo = this.$qs.parse(this.$route.query);
    if (this.$route.query.activeName) {
      this.activeName = this.$route.query.activeName;
    }
    let self = this;
    this.$http
      .get("/getUserInfo", { headers: { token: this.token } })
      .then(function(response) {
        let res = response.data;
        self.userInfo = res.mdata.userInfo;
      })
      .catch(function(response) {
        console.log(response);
      });
  },
  methods: {
    queryAllAuthorityScheme(unitNo) {
      this.$http
        .get("/admin/authorityScheme/getAll?unitNo=" + unitNo, {
          headers: { Token: this.token },
        })
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.showErrorMessage(res.message || "查询失败!");
            return;
          }
          this.authoritySchemeList = res.ldata;
          let unitMemberNo = this.editAdminData.number;
          if (unitMemberNo && unitMemberNo.length > 0) {
            this.getAdminSchemeList(unitMemberNo, res.ldata);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    queryAllUser(val) {
      this.userList = [];
      this.addUserData.number = "";
      this.getUnitMemberManageable(val, 1);
    },

    queryAllAdmin(val) {
      this.userList = [];
      this.addAdminData.number = "";
      this.getUnitMemberManageable(val, 2);
    },

    getUnitMemberManageable(val, userType) {
      let params = {
        userType: userType,
        type: 2,
        condition: val,
      };
      this.loading = true;
      let self = this;
      this.$http
        .get(
          "/admin/unit/member/getUnitMemberManageable?" +
            this.$qs.stringify(params),
          { headers: { Token: this.token } }
        )
        .then((response) => {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            this.showErrorMessage(res.message || "查询失败!");
            return;
          }
          if (userType == 1) {
            self.userList = res.ldata;
          } else {
            self.adminList = res.ldata;
          }
        })
        .catch((err) => {
          self.loading = false;
        });
    },
    queryManagedUnit(number) {
      this.$http
        .get("/admin/unit/getTrees", { headers: { Token: this.token } })
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.showErrorMessage(res.message || "查询失败!");
            return;
          }
          this.unitTree = res.ldata;
          if (number) {
            this.checkedUnitList.push(number);
          } else {
            this.checkedUnitList.push(res.ldata[0].number);
            this.unitInfo = {
              name: res.ldata[0].name,
              number: res.ldata[0].number,
              memberNum: 0,
            };
          }
          if (this.unitTree.length > 0) {
            this.beginIndex = 0;
            let unitInfo = {
              number: this.unitTree[0].number,
              name: this.unitTree[0].name,
            };
            this.$refs.tree.setCheckedKeys([unitInfo.number]);
            this.$router.push(
              "/managePage/unitMgmt?" +
                this.$qs.stringify(unitInfo) +
                "&activeName=" +
                this.activeName
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span title={node.label}> {node.label} </span>
        </span>
      );
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    queryUnitMember() {
      let params = {
        unitNo: this.unitInfo.number,
        type: 2,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
      };
      this.userLoading = true;
      this.userLoadingText = "数据加载中..."
      this.$http
        .get("/admin/unit/member/getByPaging?" + this.$qs.stringify(params), {
          headers: { Token: this.token },
        })
        .then((response) => {
          this.userLoading = false;
          let res = response.data;
          if (!res || !res.result) {
            this.showErrorMessage(res.message || "查询失败!");
            return;
          }
          this.dataList = res.ldata;
          this.resetPreAndNextBtn(this.dataList.length);
          this.dataList.length > this.pageSize && this.dataList.pop();
        })
        .catch((err) => {
          this.userLoading = false;
        });
    },
    onEditUnitInfoBtnClick() {
      Object.assign(this.editUnitInfo, this.unitInfo);
      this.editUnitInfoDialogVisible = true;
    },
    editUnitInfoConfirm() {
      let params = {
        number: this.editUnitInfo.number,
        name: this.editUnitInfo.name,
      };
      this.$http
        .get("/admin/unit/createOrUpdate?" + this.$qs.stringify(params), {
          headers: { Token: this.token },
        })
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.showErrorMessage(res.message || "查询失败!");
            return;
          }
          this.editUnitInfoDialogVisible = false;
          this.$message({
            type: "success",
            message: "编辑成功",
            center: true,
          });
          Object.assign(this.unitInfo, this.editUnitInfo);
          this.queryManagedUnit(this.editUnitInfo.number);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    queryUnitAdmin() {
      let params = {
        unitNo: this.unitInfo.number,
      };
      this.userLoading = true;
      this.userLoadingText = "数据加载中...";
      this.$http
        .get(
          "/admin/unit/member/getAdminUnderUnit?" + this.$qs.stringify(params),
          { headers: { Token: this.token } }
        )
        .then((response) => {
          this.userLoading = false;
          let res = response.data;
          if (!res || !res.result) {
            this.showErrorMessage(res.message || "查询失败!");
            return;
          }
          this.dataList = res.ldata;
        })
        .catch((err) => {
          this.userLoading = false;
        });
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.dataList = [];
      if (this.memberType == 1) {
        this.queryUnitMember();
      } else {
        this.queryUnitAdmin();
      }
    },
    onAddAdminBtnClick() {
      this.addAdminData.number = "";
      this.queryAllAuthorityScheme(this.unitInfo.number);
      this.addAdminData.schemeList = [];
      this.addAdminDialogVisible = true;
    },
    onAddAdminConfirm() {
      let params = {
        unitMemberNo: this.addAdminData.number,
        unitNo: this.unitInfo.number,
        authoritySchemeNo: this.addAdminData.schemeList,
      };
      this.$http
        .post(
          "/admin/unit/member/authorityScheme/createOrUpdate",
          JSON.stringify(params),
          {
            headers: {
              Token: this.token,
              "Content-Type": "application/json;charset=UTF-8",
            },
          }
        )
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true,
            });
            return;
          }
          this.addAdminDialogVisible = false;
          this.$message({
            type: "success",
            message: "添加成功",
            center: true,
          });
          this.onQueryBtnClick();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onAddUserBtnClick() {
      this.addUserData.number = "";
      this.addUserDialogVisible = true;
    },
    onAddUserConfirm() {
      let params = {
        unitNo: this.unitInfo.number,
        type: 2,
        sourceNo: this.addUserData.number,
      };
      this.$http
        .get(
          "/admin/unit/member/createOrUpdate?" + this.$qs.stringify(params),
          { headers: { Token: this.token } }
        )
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true,
            });
            return;
          }
          this.addUserDialogVisible = false;
          this.$message({
            type: "success",
            message: "添加成功",
            center: true,
          });
          this.queryUnitMember();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleFile(file, fileList) {
      this.file = file.raw;
      return false;
    },
    onImportBtnClick() {
      this.file = null;
      this.uploadDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.fileUpload.clearFiles();
      });
    },
    onImportBtnConfirm() {
      let params = {
        unitNo: this.unitInfo.unitNo,
        uploadFile: this.file,
      };
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      this.$http
        .post("/managementPlatform/unit/addUnitMemberByFile", formData)
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true,
            });
            return;
          }
          this.uploadDialogVisible = false;
          this.$message({
            type: "success",
            message: "上传成功",
            center: true,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onExportBtnClick() {
      let params = {
        unitNo: this.unitInfo.unitNo,
        phoneAndName: this.phoneAndName,
        authoritySchemeNo: this.authoritySchemeNo,
      };
      this.$http
        .post(
          "/managementPlatform/electricity/userAuthoritySchemeExport",
          this.$qs.stringify(params)
        )
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true,
            });
            return;
          }
          this.$router.push("/managePage/downloadTask");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onEditUserBtnClick(item) {
      this.editUserData.number = item.unitMemberNo;
      this.editUserData.sourceNo = item.userAccountNo;
      let keys = this.$refs.tree.getHalfCheckedKeys();
      keys.push(this.unitInfo.number);
      this.editUserData.unitNo = keys;
      this.editUserDialogVisible = true;
    },
    onEditUserConfirm() {
      let params = {
        number: this.editUserData.number,
        unitNo: this.editUserData.unitNo[this.editUserData.unitNo.length - 1],
        type: 2,
        sourceNo: this.editUserData.sourceNo,
      };
      this.$http
        .get(
          "/admin/unit/member/createOrUpdate?" + this.$qs.stringify(params),
          { headers: { Token: this.token } }
        )
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true,
            });
            return;
          }
          this.editUserDialogVisible = false;
          this.$message({
            type: "success",
            message: "编辑成功",
            center: true,
          });
          this.queryUnitMember();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onDeleteUserBtnClick(item) {
      this.$confirm("是否确认删除？").then(() => {
        this.deleteUser(item.unitMemberNo);
      });
    },
    deleteUser(number) {
      let params = {
        number: number,
      };
      this.$http
        .get("/admin/unit/member/delete?" + this.$qs.stringify(params), {
          headers: { Token: this.token },
        })
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true,
            });
            return;
          }
          this.$message({
            type: "success",
            message: "删除成功",
            center: true,
          });
          this.queryUnitMember();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onEditAdminBtnClick(item) {
      this.editAdminData.number = item.unitMemberNo;
      this.queryAllAuthorityScheme(this.unitInfo.number);
      // this.getAdminSchemeList(item.unitMemberNo);
      this.editAdminDialogVisible = true;
    },
    getAdminSchemeList(number, authoritySchemeList) {
      let params = {
        unitMemberNo: number,
        unitNo: this.unitInfo.number,
      };
      this.$http
        .get(
          "/admin/authorityScheme/getAuthoritySchemeUnderUnit?" +
            this.$qs.stringify(params),
          { headers: { Token: this.token } }
        )
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "查询失败!",
              center: true,
            });
            return;
          }
          let schemeList = [];
          let extraSchemeList = [];
          for (let v of res.ldata) {
            if (
              authoritySchemeList.findIndex((item) => item.number == v.number) >
              -1
            ) {
              schemeList.push(v.number);
            } else {
              extraSchemeList.push(v);
            }
          }
          this.editAdminData.schemeList = schemeList;
          this.editAdminData.extraSchemeList = extraSchemeList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onEditAdminConfirm() {
      let extra = [];
      this.editAdminData.extraSchemeList.forEach((item) => {
        extra.push(item.number);
      });
      let params = {
        unitMemberNo: this.editAdminData.number,
        unitNo: this.unitInfo.number,
        authoritySchemeNo: this.editAdminData.schemeList.concat(extra),
      };
      this.$http
        .post(
          "/admin/unit/member/authorityScheme/createOrUpdate",
          JSON.stringify(params),
          {
            headers: {
              Token: this.token,
              "Content-Type": "application/json;charset=UTF-8",
            },
          }
        )
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true,
            });
            return;
          }
          this.editAdminDialogVisible = false;
          this.$message({
            type: "success",
            message: "编辑成功",
            center: true,
          });
          this.onQueryBtnClick();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onDeleteAdminBtnClick(item) {
      this.$confirm("是否确认删除？").then(() => {
        this.deleteAdmin(item.unitMemberNo);
      });
    },
    deleteAdmin(number) {
      let params = {
        number: number,
      };
      this.$http
        .get(
          "/admin/unit/member/authorityScheme/delete?" +
            this.$qs.stringify(params),
          { headers: { Token: this.token } }
        )
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true,
            });
            return;
          }
          this.$message({
            type: "success",
            message: "删除成功",
            center: true,
          });
          this.queryUnitAdmin();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onDeleteUnitBtnClick() {
      this.$confirm("是否确认删除？").then(() => {
        this.deleteUnit();
      });
    },
    deleteUnit() {
      let params = {
        number: this.unitInfo.number,
      };
      this.$http
        .get("/admin/unit/delete?" + this.$qs.stringify(params), {
          headers: { Token: this.token },
        })
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true,
            });
            return;
          }
          this.$message({
            type: "success",
            message: "删除成功",
            center: true,
          });
          this.queryManagedUnit();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onAddUnitBtnClick() {
      this.addUnitData.name = "";
      this.addUnitDialogVisible = true;
    },
    onAddUnitConfirm() {
      let params = {
        belongUnitNo: this.unitInfo.number,
        name: this.addUnitData.name,
      };
      this.$http
        .get("/admin/unit/createUnderUnit?" + this.$qs.stringify(params), {
          headers: { Token: this.token },
        })
        .then((response) => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true,
            });
            return;
          }
          this.addUnitDialogVisible = false;
          this.$message({
            type: "success",
            message: "新增成功",
            center: true,
          });
          this.queryManagedUnit(this.unitInfo.number);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleNodeClick(item) {
      const unitInfo = {
        number: item.number,
        name: item.name,
      };
      this.beginIndex = 0;
      this.$refs.tree.setCheckedKeys([unitInfo.number]);
      this.$router.push(
        "/managePage/unitMgmt?" +
          this.$qs.stringify(unitInfo) +
          "&activeName=" +
          this.activeName
      );
    },
    onPreBtnClick: function() {
      this.beginIndex -= this.pageSize;
      this.queryUnitMember();
    },
    onNextBtnClick: function() {
      this.beginIndex += this.pageSize;
      this.queryUnitMember();
    },
    resetPreAndNextBtn: function(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    showErrorMessage(message) {
      if (message == "0000") {
        this.$message({
          type: "warning",
          message: "请先登录",
          center: true,
        });
      } else if (message == "0001") {
        this.$message({
          type: "warning",
          message: "未认证",
          center: true,
        });
      } else if (message == "0002") {
        this.$message({
          type: "warning",
          message: "无权限",
          center: true,
        });
      } else {
        this.$message({
          type: "error",
          message: message,
          center: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-body {
  width: 100%;
  padding: 10px;
  margin: 0;
  display: flex;
  box-sizing: border-box;
  height: 90%;
}

.side-bar {
  min-height: 100%;
  border-right: 1px solid #ccc;

}

.main-box {
  flex: 1;
  padding: 10px;
  min-height: 460px;
}
</style>



// WEBPACK FOOTER //
// src/components/unitMgmt.vue